import { Pipe, PipeTransform } from '@angular/core';
import { head } from 'lodash';

@Pipe({ name: 'head' })
export class HeadPipe implements PipeTransform {
  transform(data: any[]): any {
    return head(data);
  }
}
